var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.0312 5.67188H15.5156V2.10938C15.5156 0.946266 14.5694 0 13.4062 0H4.96875C3.80564 0 2.85938 0.946266 2.85938 2.10938V16.2188C2.85938 17.3819 3.80564 18.3281 4.96875 18.3281H8.48438V21.8906C8.48438 23.0537 9.43064 24 10.5938 24H19.0312C20.1944 24 21.1406 23.0537 21.1406 21.8906V7.78125C21.1406 6.61814 20.1944 5.67188 19.0312 5.67188ZM4.26562 16.2188V2.10938C4.26562 1.72167 4.58105 1.40625 4.96875 1.40625H13.4062C13.794 1.40625 14.1094 1.72167 14.1094 2.10938V16.2188C14.1094 16.6065 13.794 16.9219 13.4062 16.9219H4.96875C4.58105 16.9219 4.26562 16.6065 4.26562 16.2188ZM19.7344 21.8906C19.7344 22.2783 19.419 22.5938 19.0312 22.5938H10.5938C10.206 22.5938 9.89062 22.2783 9.89062 21.8906V18.3281H13.4062C14.5694 18.3281 15.5156 17.3819 15.5156 16.2188V7.07812H19.0312C19.419 7.07812 19.7344 7.39355 19.7344 7.78125V21.8906Z",
    fill: "#D2042D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicate-icon.d2ce31fd6442188262cec8761c24ead8.svg";
export { ForwardRef as ReactComponent };